import { call, put, takeLatest } from 'redux-saga/effects';
import { toast } from 'react-toastify';
import {
  ThirdPartyLogisticsActions,
  thirdPartyLogisticsTypes,
} from '../store/slices/thirdPartyLogisticsSlice';
import ThirdPartyLogisticsService from '../services/ThirdPartyLogisticsService';

export const createThirdPartyLogistics = function* (action) {
  try {
    // Dispatch loading action to set loading to true
    yield put(ThirdPartyLogisticsActions.setLoading());
    const response = yield call(
      ThirdPartyLogisticsService.getThirdPartyLogistics,
      action.payload
    );
    // If the response is successful (status 201)
    if (response.status === 201) {
      yield put(
        ThirdPartyLogisticsActions.createThirdPartyLogistics(response?.status)
      );
      toast.success(response?.data?.message);
    }
  } catch (err) {
    // If an error occurs, dispatch setError with the error message
    toast.error(err?.response?.data?.message || err.message);
  } finally {
    // Reset loading state, whether the request succeeds or fails
    yield put(ThirdPartyLogisticsActions.resetLoadingAndError());
  }
};

// Watcher saga
export default function* thirdPartyLogisticsSaga() {
  // Listening for the CREATE_SERVICE action and triggering createServices
  yield takeLatest(
    thirdPartyLogisticsTypes.CREATE_THIRD_PARTY_LOGISTICS,
    createThirdPartyLogistics
  );
}
